import { render } from "./TosPage.vue?vue&type=template&id=448aa8bc&scoped=true"
import script from "./TosPage.vue?vue&type=script&lang=js"
export * from "./TosPage.vue?vue&type=script&lang=js"

import "./TosPage.vue?vue&type=style&index=0&id=448aa8bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448aa8bc"]])

export default __exports__